import { getRegisterFunction } from '../../utils/register.js';
import { OneUxDatePickerElement } from './OneUxDatePickerElement.js';
export const register = getRegisterFunction(OneUxDatePickerElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-date-picker': OneUxDatePickerElement;
    "date-picker-831b375f37095fad5ba8a13c27e51cef": OneUxDatePickerElement;
  }
}